module.exports = __webpack_public_path__ + "img/IAR7.60d7c38c.png";